import {ValueObject} from '@s-ui/domain'

export default class RelatedAdsRequestValueObject extends ValueObject {
  /**
   * @constructor
   * @param {Object} params
   * @param {Number|String} params.adId
   * @param {Number|String} params.modelId
   * @param {Number|String} params.count
   * @param {Number} params.offerTypeId
   * @param {String} params.preferredContractModes
   * @param {String} params.subscriptionContext
   */
  constructor({adId, count, modelId, offerTypeId, preferredContractModes, subscriptionContext}) {
    super({
      adId,
      count,
      modelId,
      offerTypeId,
      preferredContractModes,
      subscriptionContext
    })
  }

  isValid() {
    return Boolean(this._adId && this._count) || Boolean(this._modelId && this._count)
  }
}
